import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "store/types";

interface PrivateRouteProps {
  children: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const auth = useSelector((state: RootState) => state.auth);
  const isAuthenticated = !!auth.accessToken && !!auth.userId;

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
